import React from 'react';
import type { AccountProps } from '../../types';
import { Icons } from '../../Components';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';
import { WalletHelpers } from '../api';

type AccountCardProps = {
    account:AccountProps,
    hide_status?:boolean,
    onSelectAccount: (account:AccountProps) => void
}

const AccountCard = ({ account, hide_status, onSelectAccount }: AccountCardProps) => {
    const Colors = useColors();

    const getIcon = () => {
        switch(account.account_type){
            case 'ach':
                if(account.ach_detail?.payment_provider == 'nuvei'){ return <Icons.BankInstantIcon size={28} color={Colors.text.h1}/> }
                return <Icons.BankIcon size={28} color={Colors.text.success} />
            case 'card':
                return renderCardIcon(account.card_detail?.card_brand)
            case 'paypal':
                return <Icons.PayPalIcon size={20}/>
            default: return <></>

        }
    }

    const renderCardIcon = (brand?:string) => {
        switch(brand?.toLowerCase()){
            case 'amex':
                return <Icons.AmexCardIcon size={28} />
            case 'visa':
                return <Icons.VisaCardIcon size={28} />
            case 'mastercard':
                return <Icons.MasterCardIcon size={28} />
            case 'discover':
                return <Icons.DiscoverCardIcon size={28} />
            default:
                return <Icons.CreditCardIcon size={22} color={Colors.text.h1}/>
        }
    }

    const getStatusColor = () => {
        switch(account.status){
            case 'active': return Colors.text.success
            case 'inactive': return Colors.text.error
            case 'suspended': return Colors.text.warning
            case 'verify': return Colors.text.warning
            default: return Colors.text.h1
        }
    }

    const getDescriptionLabel = () => {
        switch(account.account_type){
            case 'ach':
                if(!account.ach_detail){ return '' }
                if(account.ibt_placeholder){ return `Securely link a new account and transact instantly` }
                return account.ach_detail.account_type.toUpperCase()
            case 'card':
                if(!account.card_detail){ return '' }
                return `EXP ${WalletHelpers.formateTimeToExpireDate(account.card_detail.expiration_date)}`
            case 'paypal':
                return `Login to your Paypal and transact`
            default: return ''
        }
    }

    return (
        <Button 
            style={{ padding:10 }}
            float
            onPress={() => onSelectAccount(account)}    
        >
            <View transparent style={{ flexDirection:'row' }}>
                <View transparent style={{ marginRight:10, justifyContent:'center', alignItems:'center' }}>
                    {getIcon()}
                </View>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>{account.account_label}</Text>
                    <Text style={{ marginTop:4 }} theme='description'>{getDescriptionLabel()}</Text> 
                </View>
                {!hide_status ?
                <View transparent>
                    <Text size={12} color={getStatusColor()} weight='bold'>{account.status.toUpperCase()}</Text>
                </View>
                :<></>}
            </View>
        </Button>
    )
}


export default AccountCard